// Sample portfolio data - replace with actual images and content
export const commissionedWork = [
  {
    id: "1",
    title: "ICC World Cup",
    image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=500&fit=crop&crop=center",
    category: "Sports",
    photos: [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&h=600&fit=crop&crop=center",
      "https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=800&h=600&fit=crop&crop=center",
      "https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=800&h=600&fit=crop&crop=center",
      "https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=800&h=600&fit=crop&crop=center"
    ],
    description: "Official photography for ICC World Cup event"
  },
  {
    id: "2",
    title: "Chris Hemsworth x DCT",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=500&fit=crop&crop=center",
    category: "Celebrity",
    photos: [
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&h=600&fit=crop&crop=center",
      "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=800&h=600&fit=crop&crop=center",
      "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=800&h=600&fit=crop&crop=center"
    ],
    description: "Celebrity shoot with Chris Hemsworth for DCT campaign"
  },
  {
    id: "3",
    title: "E&",
    image: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=500&fit=crop&crop=center",
    category: "Fashion",
    photos: [
      "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=800&h=600&fit=crop&crop=center",
      "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=800&h=600&fit=crop&crop=center",
      "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=800&h=600&fit=crop&crop=center"
    ],
    description: "Fashion editorial for E& magazine"
  },
  {
    id: "4",
    title: "Ranveer Singh x McDonald's",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=500&fit=crop&crop=center",
    category: "Commercial",
    photos: [
      "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=800&h=600&fit=crop&crop=center",
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&h=600&fit=crop&crop=center",
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=800&h=600&fit=crop&crop=center"
    ],
    description: "Commercial campaign with Ranveer Singh for McDonald's"
  },
  {
    id: "5",
    title: "ZKYB x Yas Island",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=500&fit=crop&crop=center",
    category: "Travel",
    photos: [
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=800&h=600&fit=crop&crop=center",
      "https://images.unsplash.com/photo-1506905925346-14b5e4c4b6c4?w=800&h=600&fit=crop&crop=center",
      "https://images.unsplash.com/photo-1519501025264-65ba15a82390?w=800&h=600&fit=crop&crop=center"
    ],
    description: "Travel photography for ZKYB at Yas Island"
  },
  {
    id: "6",
    title: "Manchester City x Etisalat",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=500&fit=crop&crop=center",
    category: "Sports",
    photos: [
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=800&h=600&fit=crop&crop=center",
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&h=600&fit=crop&crop=center",
      "https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=800&h=600&fit=crop&crop=center"
    ],
    description: "Sports photography for Manchester City x Etisalat partnership"
  },
  {
    id: "7",
    title: "Rashmika Mandanna x Crocs",
    image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=500&fit=crop&crop=center",
    category: "Fashion",
    photos: [
      "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=800&h=600&fit=crop&crop=center",
      "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=800&h=600&fit=crop&crop=center",
      "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=800&h=600&fit=crop&crop=center"
    ],
    description: "Fashion campaign with Rashmika Mandanna for Crocs"
  },
  {
    id: "8",
    title: "Jason Momoa x Yas Island",
    image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=500&fit=crop&crop=center",
    category: "Celebrity",
    photos: [
      "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=800&h=600&fit=crop&crop=center",
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&h=600&fit=crop&crop=center",
      "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=800&h=600&fit=crop&crop=center"
    ],
    description: "Celebrity shoot with Jason Momoa at Yas Island"
  },
  {
    id: "9",
    title: "Ranveer Singh x Yas Island",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=500&fit=crop&crop=center",
    category: "Travel",
    photos: [
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&h=600&fit=crop&crop=center",
      "https://images.unsplash.com/photo-1506905925346-14b5e4c4b6c4?w=800&h=600&fit=crop&crop=center",
      "https://images.unsplash.com/photo-1519501025264-65ba15a82390?w=800&h=600&fit=crop&crop=center"
    ],
    description: "Travel photography with Ranveer Singh at Yas Island"
  },
  {
    id: "10",
    title: "Rashmika Mandanna x CMF Nothing",
    image: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=500&fit=crop&crop=center",
    category: "Tech",
    photos: [
      "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=800&h=600&fit=crop&crop=center",
      "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=800&h=600&fit=crop&crop=center",
      "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=800&h=600&fit=crop&crop=center"
    ],
    description: "Tech campaign with Rashmika Mandanna for CMF Nothing"
  },
  {
    id: "11",
    title: "Acropora by Kresha Bajaj",
    image: "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=400&h=500&fit=crop&crop=center",
    category: "Fashion",
    photos: [
      "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=800&h=600&fit=crop&crop=center",
      "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=800&h=600&fit=crop&crop=center",
      "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=800&h=600&fit=crop&crop=center"
    ],
    description: "Fashion editorial for Acropora by Kresha Bajaj"
  },
  {
    id: "12",
    title: "Ananya Panday x Amazon",
    image: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&h=500&fit=crop&crop=center",
    category: "Commercial",
    photos: [
      "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=800&h=600&fit=crop&crop=center",
      "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=800&h=600&fit=crop&crop=center",
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&h=600&fit=crop&crop=center"
    ],
    description: "Commercial campaign with Ananya Panday for Amazon"
  }
];

export const personalWork = [
  {
    id: 1,
    title: "Urban Landscapes",
    image: "https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=400&h=500&fit=crop&crop=center",
    category: "Street"
  },
  {
    id: "2",
    title: "Nature's Beauty",
    image: "https://images.unsplash.com/photo-1506905925346-14b5e4c4b6c4?w=400&h=500&fit=crop&crop=center",
    category: "Nature"
  },
  {
    id: "3",
    title: "Abstract Forms",
    image: "https://images.unsplash.com/photo-1541961017774-22349e4a1262?w=400&h=500&fit=crop&crop=center",
    category: "Abstract"
  },
  {
    id: "4",
    title: "City Lights",
    image: "https://images.unsplash.com/photo-1519501025264-65ba15a82390?w=400&h=500&fit=crop&crop=center",
    category: "Urban"
  },
  {
    id: "5",
    title: "Minimalist",
    image: "https://images.unsplash.com/photo-1506905925346-14b5e4c4b6c4?w=400&h=500&fit=crop&crop=center",
    category: "Minimal"
  },
  {
    id: "6",
    title: "Emotional Portraits",
    image: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=500&fit=crop&crop=center",
    category: "Portrait"
  }
];

export const headshots = [
  {
    id: 1,
    title: "Corporate Headshot",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=500&fit=crop&crop=center",
    category: "Professional"
  },
  {
    id: "2",
    title: "Actor Portfolio",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=500&fit=crop&crop=center",
    category: "Actor"
  },
  {
    id: "3",
    title: "Executive Portrait",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=500&fit=crop&crop=center",
    category: "Executive"
  },
  {
    id: "4",
    title: "Creative Portrait",
    image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=500&fit=crop&crop=center",
    category: "Creative"
  },
  {
    id: "5",
    title: "Lifestyle Portrait",
    image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=500&fit=crop&crop=center",
    category: "Lifestyle"
  },
  {
    id: "6",
    title: "Fashion Headshot",
    image: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=500&fit=crop&crop=center",
    category: "Fashion"
  }
];
